import { createContext } from "react";

export enum BackgroundColorTokens {
  BACKGROUND_WHITE = "pageWhiteBackground",
  BACKGROUND_DEFAULT = "",
}

export enum PageTypesForBackground {
  HOMEPAGE = "Homepage,U,10",
  FLIGHT_LP = "page.Flights,F,10",
  HOTEL_LP = "page.Hotels,H,10",
  PACKAGE_LP = "page.Packages,P,10",
  CARS_LP = "page.Cars,C,10",
  CRUISES_LP = "page.Cruises,CR,10",
  ACTIVITIES_LP = "page.Activities,A,10",
}

export const PageBackgroundContext = createContext(BackgroundColorTokens.BACKGROUND_DEFAULT);
